import { useDeviceStore } from '@/stores/device'
import { useAdminOnly } from '@/composables/useAdminOnly'

export const baseRoutes = [
  // Base
  {
    path: 'base',
    redirect: () => {
      const { canShowBaseScreenContent } = useAdminOnly()
      // 无屏幕时跳过 pages / player，直接进入灯光
      const { currentDevice } = useDeviceStore()
      const hasScreen = currentDevice?.manifest.capabilities?.some(
        (c) => c.type === 'baseScreen' && c.config.screenType === 'screen',
      )
      // 有屏幕 + 满足 admin-only 条件 → pages，否则 → light
      if (hasScreen && canShowBaseScreenContent.value) return { name: 'base-pages' }
      return { name: 'base-light' }
    },
  },
  {
    path: 'base/pages',
    name: 'base-pages',
    meta: { type: 'base', adminOnly: true },
    component: () => import('@/views/device/base/pages/index.vue'),
  },
  {
    path: 'base/player',
    name: 'base-player',
    meta: { type: 'base', adminOnly: true },
    component: () => import('@/views/device/base/player/index.vue'),
  },
  {
    path: 'base/light',
    name: 'base-light',
    meta: { type: 'base' },
    component: () => import('@/views/device/base/light/index.vue'),
  },
  {
    path: 'base/settings',
    name: 'base-settings',
    meta: { type: 'base' },
    component: () => import('@/views/device/base/settings/index.vue'),
  },
]
